export const CONVERSION_POLL_INTERVAL = 2000
export const PROGRESS_DELAY = 500
export const QUALITY_CHECK_POLL_INTERVAL = 2000
export const QUALITY_CHECK_RETRY_ATTEMPTS = 5
export const UPLOAD_PROGRESS_INTERVAL = 1000
